import { gql, type TypedDocumentNode } from "@apollo/client";

export type SectionGovernanceRoleEmailNode = {
  id: string;
  title: { id: string; title: string } | null;
  person: { id: string; email: string | null } | null;
};

export type SectionGovernanceRoleEmailsQueryData = {
  section: {
    id: string;
    governanceRoles: SectionGovernanceRoleEmailNode[];
  } | null;
};

export type SectionGovernanceRoleEmailsQueryVariables = {
  sectionId: string;
};

export const SECTION_GOVERNANCE_ROLE_EMAILS_QUERY: TypedDocumentNode<
  SectionGovernanceRoleEmailsQueryData,
  SectionGovernanceRoleEmailsQueryVariables
> = gql`
  query SectionGovernanceRoleEmails($sectionId: ID!) {
    section(id: $sectionId) {
      id
      governanceRoles(status: ACTIVE) {
        id
        title {
          id
          title
        }
        person {
          id
          email
        }
      }
    }
  }
`;
